<script lang="ts">
    import {getSanitize} from 'src/core';
    import type {MessageSendingInternal} from 'src/typings';
    import KpMessageSendingLabeledInfo from './KpMessageSendingLabeledInfo.svelte';

    export let sending: MessageSendingInternal;

    const sanitizeHtml = getSanitize();
</script>

<KpMessageSendingLabeledInfo title="Obsah:">
    {@html sanitizeHtml(sending.body)}
</KpMessageSendingLabeledInfo>